export default "__VITE_ASSET__ae1673c8__"